/*
 * Ein Zuruf im Browser: „gerade wurde eine Anfrage abgeschickt".
 *
 * Der Anlass: Wer den Hilfe-Knopf drückt, während „Meine Anfragen" offen ist,
 * bekam danach weiter „Sie haben noch keine Anfrage gestellt" zu sehen — die
 * Liste stand seit dem Anzeigen der Seite da und wusste vom Absenden nichts.
 * Und der Verweis in der Bestätigung führt auf **dieselbe** Seite, holt sie
 * also auch nicht neu.
 *
 * Warum ein Ereignis am Fenster und kein Zustand im Store: Die beiden Stellen
 * kennen einander sonst nicht — der Knopf hängt in `App.js`, die Liste ist eine
 * Seite. Ein Zweig im Store für eine einzige Meldung wäre mehr Gerüst als
 * Sache, und ein Verweis von der Liste in das Formular hinein wäre eine
 * Abhängigkeit in die falsche Richtung.
 */

export const ANFRAGE_GESENDET = 'junior:request-sent'

/** Sagt allen offenen Ansichten, dass es eine neue Anfrage gibt. */
export const meldeAnfrageGesendet = id => {
	window.dispatchEvent(new CustomEvent(ANFRAGE_GESENDET, { detail: { id } }))
}
